import { render, staticRenderFns } from "./JitsiClient2.vue?vue&type=template&id=6e8d4be2&"
import script from "./JitsiClient2.vue?vue&type=script&lang=js&"
export * from "./JitsiClient2.vue?vue&type=script&lang=js&"
import style0 from "./JitsiClient2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports